export enum MULTI_REACTIONS {
    /**
     * @value {"one":"Change %REACTION% reaction, %TOTAL% reaction","other":"Change %REACTION% reaction, %TOTAL% reactions"}
     * @description Display an aria-label message on the multi-reaction trigger button, when the current user has already react with %REACTION% and might want to change he's reaction.
     */
    CHANGE_REACTION_ARIA_LABEL = 'MULTI_REACTIONS.CHANGE_REACTION_ARIA_LABEL',
    /**
     * @value {"one":"React, %TOTAL% reaction","other":"React, %TOTAL% reactions"}
     * @description Display an aria-label message on the multi-reaction button, when there has not been any reaction from the user. Encourage the user to add a new reaction.
     */
    REACT_ARIA_LABEL = 'MULTI_REACTIONS.REACT_ARIA_LABEL',
}
